import React from "react";



const Process = () => {

   return(
    <>
       <section className="section process-section">
            <div className="container">
                <div className="row">
                    <div className="col-md-9">
                        <div className="heading-title">
                            <h1>My UX Design <span>Process</span></h1>
                            <p>I follow a human-centered design approach to create simple, usable, and meaningful digital experiences. Every step is focused on understanding users and turning ideas into effective solutions.</p>
                        </div>
                    </div>
                </div>
                <div className="procees-designFlow">
                    <div className="card-process">
                        <div className="process-heading">
                             <h2> Empathize</h2>
                        </div>
                        <div className="label-flow">
                            <p>I start by understanding the users — their needs, goals, behaviors, and pain points. This helps me see the problem from their perspective.</p> <br />
                            <p className="focus-paragraph">User research, insights, real-world problems</p>
                        </div>
                    </div>
                  
                    <div className="card-process">
                        <div className="process-heading">
                             <h2>Define</h2>
                        </div>
                        <div className="label-flow">
                            <p>I analyze the research findings and clearly define the core problem that needs to be solved. This step helps set the right direction for the design process.</p> <br />
                            <p className="focus-paragraph">Problem statement, user needs, clarity</p>
                        </div>
                    </div>

                    <div className="card-process">
                        <div className="process-heading">
                             <h2>Ideate</h2>
                        </div>
                        <div className="label-flow">
                            <p>I explore multiple ideas and possible solutions to solve the defined problem. This is where creativity and strategy come together.</p> <br />
                            <p className="focus-paragraph">User research, insights, real-world problems</p>
                        </div>
                    </div>

                    <div className="card-process">
                        <div className="process-heading">
                             <h2>Prototype</h2>
                        </div>
                        <div className="label-flow">
                            <p>I turn ideas into tangible designs by creating wireframes and interactive prototypes. This helps visualize the product early in the process.</p> <br />
                            <p className="focus-paragraph">Wireframes, UI structure, clickable prototype</p>
                        </div>
                    </div>

                     <div className="card-process">
                        <div className="process-heading">
                             <h2>Test</h2>
                        </div>
                        <div className="label-flow">
                            <p>I test the design with real users to gather feedback, identify issues, and improve usability. This ensures the final product is user-friendly and effective.</p> <br />
                            <p className="focus-paragraph">Usability testing, feedback, iteration</p>
                        </div>
                    </div>
                </div>
            </div>
       </section>
       
    </>
   );
}

export default Process;
